import { useTranslation } from "react-i18next";
import EmptyState from "src/features/statsNew/components/EmptyState";

export const NoMediaPlaceholder = () => {
  const { t } = useTranslation();
  return (
    <EmptyState
      icon="search"
      title={t("statsNew.emptyState.noSearchResults")}
      description={t("statsNew.emptyState.noSearchResultsDescription")}
    />
  );
};
